import { render } from "./SpkSubconUpdate.vue?vue&type=template&id=a5789108&scoped=true"
import script from "./SpkSubconUpdate.vue?vue&type=script&lang=js"
export * from "./SpkSubconUpdate.vue?vue&type=script&lang=js"

import "./SpkSubconUpdate.vue?vue&type=style&index=0&id=a5789108&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5789108"]])

export default __exports__